import React, { useEffect, useState } from 'react';
import { UsersIcon } from 'lucide-react';
export function LiveVisitorCounter() {
  const [visitors, setVisitors] = useState(42);
  useEffect(() => {
    const interval = setInterval(() => {
      setVisitors(prev => {
        // Fluctuate between 35 and 65
        const change = Math.floor(Math.random() * 5) - 2;
        const next = prev + change;
        if (next < 35) return 35;
        if (next > 65) return 65;
        return next;
      });
    }, 5000);
    return () => clearInterval(interval);
  }, []);
  return <div className="flex items-center justify-center space-x-2 text-sm font-medium text-gray-600 bg-white py-2 px-4 rounded-full shadow-sm border border-gray-100 w-fit mx-auto" data-id="element-59">
      <UsersIcon className="h-4 w-4 text-green-600" data-id="element-60" />
      <span data-id="element-61">{visitors} personas están viendo esta página ahora</span>
    </div>;
}